export const wysiwygTranslations = {
  en: () => import('@recruitee/prosemirror/locales/src/en.json').then(t => ({ en: t.default })),
  de: () => import('@recruitee/prosemirror/locales/src/de.json').then(t => ({ de: t.default })),
  fr: () => import('@recruitee/prosemirror/locales/src/fr.json').then(t => ({ fr: t.default })),
  nl: () => import('@recruitee/prosemirror/locales/src/nl.json').then(t => ({ nl: t.default })),
  sv: () => import('@recruitee/prosemirror/locales/src/sv.json').then(t => ({ sv: t.default })),
  fi: () => import('@recruitee/prosemirror/locales/src/fi.json').then(t => ({ fi: t.default })),
};
